<template>
	<div>
		<ProjectTaskList
			:project-id="projectId"
			:retainer-period-id="retainerPeriodId"
		/>
	</div>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';
import { type RetainerPeriod, type Project } from '@/generated/graphql';

const ProjectTaskList = defineAsyncComponent(
	() =>
		import('@/features/Project/components/ProjectTaskList/ProjectTaskList.vue')
);

defineProps<{
	projectId: Project['id'];
	retainerPeriodId?: RetainerPeriod['id'];
}>();
</script>

<style lang="scss">
#planned_activities {
	* {
		box-sizing: content-box;
	}

	.col_checkbox,
	.checkbox {
		display: none;
	}

	.data-table th {
		border-bottom-width: 1px;
	}

	.col_time_spent,
	.col_duration_remaining,
	.col_deadline,
	.col_progress {
		width: 12rem;
	}

	// Selects sortable column data cells with right-aligned text
	.col_time_spent,
	.col_duration_remaining,
	.col_deadline {
		> div {
			margin-right: 2.625rem;
		}
	}

	.col_responsible_assigned_to {
		width: 10rem;
	}

	.TaskRow.is-other-users-task .event-row-data {
		color: $neutral-90;

		a {
			color: inherit;
		}
	}

	#planned-activities-elements .TaskRow .eventName {
		white-space: normal;
		display: -webkit-box;
		-webkit-line-clamp: 1;
		-webkit-box-orient: vertical;
		overflow: hidden;
		overflow-wrap: break-word;
	}

	#planned-activities-elements .TaskRow .eventNameWrapper {
		max-width: none;
	}
}
</style>
